import StyleWrapper from 'publisher/components/core/StyleWrapper'
import FieldErrors from 'publisher/components/FieldErrors'
import useCustomLoginSubmit from 'publisher/hooks/use-custom-login-submit'
import React, { memo } from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/publisher/shared/hooks/use-theme-color/use-selected-button-color'
import { Button as CommonButton } from 'src/shared/components/button/button'
import { CustomLoginButtonEntityInterface } from 'src/shared/entities/button/custom-login-button.schema'

const TEST_ID = 'custom-login-button'

export interface CustomLoginButtonProps {
  entity: CustomLoginButtonEntityInterface
}

const CustomLoginButton = ({ entity }: CustomLoginButtonProps) => {
  const [isLoading, errors, submit] = useCustomLoginSubmit(entity)

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    // calculatedTextAlign,
    // calculatedLetterSpacing,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
  })

  const {
    buttonTextColor,
    buttonBackgroundColor,
    hoveredButtonBackgroundColor,
  } = useSelectedButtonColor(entity.buttonType)

  return (
    <StyleWrapper
      flex
      flexColumn
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonButton
        dataTestId={TEST_ID}
        iconClassNameBefore={entity.iconClassNameBefore}
        iconClassNameAfter={entity.iconClassNameAfter}
        /* @ts-expect-error */
        onClick={submit}
        /* @ts-expect-error */
        disabled={isLoading}
        text={entity.text}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        subText={entity.subText}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        background={
          (entity.background ?? entity.backgroundColor) || buttonBackgroundColor
        }
        mobileBackground={
          (entity.mobileBackground ?? entity.mobileBackgroundColor) ||
          buttonBackgroundColor
        }
        attrId={entity.htmlAttrId}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
        textColor={entity.textColor || buttonTextColor}
        subTextColor={entity.subTextColor}
        mobileTextColor={entity.mobileTextColor || buttonTextColor}
        mobileSubTextColor={entity.mobileSubTextColor}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        subTextFontSize={entity.subTextFontSize}
        mobileSubTextFontSize={entity.mobileSubTextFontSize}
        textFontFamily={calculatedFontFamily.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        subTextFontFamily={entity.subTextFontFamily}
        subTextFontWeight={entity.subTextFontWeight}
        subTextFontStyle={entity.subTextFontStyle}
        mobileTextFontFamily={calculatedFontFamily.mobile}
        mobileTextFontWeight={calculatedFontWeight.mobile}
        mobileTextFontStyle={calculatedFontStyle.mobile}
        mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
        mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
        mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        hover={{
          ...entity.hover,
          backgroundColor:
            entity?.hover?.backgroundColor || hoveredButtonBackgroundColor,
        }}
        mobileHover={{
          ...entity.mobileHover,
          backgroundColor:
            entity?.mobileHover?.backgroundColor ||
            entity?.hover?.backgroundColor ||
            hoveredButtonBackgroundColor,
        }}
      />
      {/* @ts-ignore */}
      <FieldErrors errors={errors} align="center" />
    </StyleWrapper>
  )
}

export default memo(CustomLoginButton)
